import React, { useContext, useMemo, useState } from 'react';
import { useMutation } from 'react-query';
import { useTranslation } from 'react-i18next';
import { useBankAccountsStore } from '../store/useBankAccountsStore';
import { DeleteModal } from '../../../../../../components/DeleteModal';
import { DeleteBankAccountModalContext } from './DeleteBankAccountModalContext';
import { ToastContext } from '@weezevent/nacre';

export const DeleteBankAccountModalProvider = ({ children }) => {
    const [openedId, setOpenedId] = useState(null);
    const { deleteBankAccount, getById } = useBankAccountsStore();
    const { t } = useTranslation();
    const toaster = useContext(ToastContext);
    const entity = openedId ? getById(openedId) : null;
    const accountName = entity?.name;

    const handleError = error => {
        const detail = error?.response?.detail;
        if (typeof detail === 'string') {
            toaster.error(detail);
        } else {
            toaster.error(t('sauron.financeModule.bankAccounts.toasts.error'));
        }
    };

    const closeModal = () => {
        setOpenedId(null);
    };

    const deleteMutation = useMutation(
        () => {
            return deleteBankAccount(openedId);
        },
        {
            onSuccess: () => {
                closeModal();
                toaster.success(t('sauron.financeModule.bankAccounts.deleteModal.successToast', { name: accountName }));
            },
            onError: handleError
        }
    );

    const value = useMemo(() => {
        return {
            open: setOpenedId
        };
    }, []);

    return (
        <DeleteBankAccountModalContext.Provider value={value}>
            <DeleteModal
                onSubmit={deleteMutation.mutate}
                onCancel={closeModal}
                isSubmitting={deleteMutation.isLoading}
                open={!!openedId}
                title={t('sauron.financeModule.bankAccounts.deleteModal.title', {
                    name: accountName
                })}
                description={t('sauron.financeModule.bankAccounts.deleteModal.description')}
            />
            {children}
        </DeleteBankAccountModalContext.Provider>
    );
};
